import "../../../../../../vue@3.5.13_typescript@4.9.5/node_modules/vue/dist/vue.runtime.esm-bundler.es.js";
import { useSizeDefaults } from "../../composables/private.use-size/use-size.es.js";
import { computed } from "../../../../../../@vue_runtime-core@3.5.13/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.es.js";
const useSpinnerProps = {
  size: {
    type: [String, Number],
    default: "1em"
  },
  color: String
};
function useSpinner(props) {
  return {
    cSize: computed(() => props.size in useSizeDefaults ? `${useSizeDefaults[props.size]}px` : props.size),
    classes: computed(
      () => "q-spinner" + (props.color ? ` text-${props.color}` : "")
    )
  };
}
export {
  useSpinner as default,
  useSpinnerProps
};
//# sourceMappingURL=use-spinner.es.js.map
